import mock from '../MockConfig';

import newsData from '@crema/services/db/news/news';

mock.onGet('/news').reply(200, newsData);